
export default {
  //   components: {
  //     VideoPlayer: () => import('~/components/Modules/Common/VideoPlayer'),
  //   },
  props: {
    text: {
      type: String,
      default: '',
    },
  },
  //   data() {
  //     return {
  //       showModal: false,
  //     }
  //   },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    init() {
      // set close color
      this.$refs.close.$el.style.color = '#ffffffb3'
    },
    closeBanner() {
      this.$store.commit('setSettings', { showBanner: false })
      //   this.showBanner = false
    },
    onCloseLeave() {
      // close btn default state
      if (this.$refs?.close) this.$refs.close.$el.style.color = '#ffffffb3'
    },
    onCloseEnter() {
      // close btn hover state
      if (this.$refs?.close) this.$refs.close.$el.style.color = '#fff'
    },
    // openModal() {
    //   this.showModal = true
    // },
  },
}
